import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "../utils/utils";
import { motion } from "framer-motion";
import {
  CandlestickChart,
  ClipboardEdit,
  FileClock,
  LineChart,
} from "lucide-react";
import { Tooltip } from "@mui/material";
import {PiVaultBold} from 'react-icons/pi';
import { MdOutlineLeaderboard } from "react-icons/md";
import { IoCartOutline, IoPricetagsOutline, IoListCircleOutline } from "react-icons/io5"
import { HiOutlineShoppingCart } from "react-icons/hi";
import { TbReportSearch } from "react-icons/tb";
import { TbPresentationAnalytics } from "react-icons/tb";
import { AiOutlineStock } from "react-icons/ai";
import { MdOutlineAnalytics } from "react-icons/md";
const ROUTE_ACCESS_KEYS = {
  "/dashboard": "dashboard",
  "/price_co-pilot": "pricing_co_pilot",
  "/inventory_report": "bi_inventory",
  "/sale_report": "bi_sales",
  "/stock_performance": "stock_performance",
  "/saved_search": "pricing_saved_searches",
  "/market_performance": "market_performance",
  "/selection": "selection",
};

const SidebarContent = ({ isVisible, userAccess }) => {
  const allRoutes = {
    "/dashboard": "Dashboard",
    "/price_co-pilot": "Pricing Co-Pilot",
    "/inventory_report": "BI-Inventory",
    "/sale_report": "BI-Sales",
    "/stock_performance": "Stock Performance",
    "/saved_search": "Saved Searches",
    // "/market_intelligence": "Market Intelligence",
    "/market_performance": "Market Performance",
    "/selection": "Recommendation",
    // "/aging_report": "Aging Report",
  };

  const routes = Object.fromEntries(
    Object.entries(allRoutes).filter(([path]) => {
      const key = ROUTE_ACCESS_KEYS[path];
      return !userAccess || !key || userAccess[key] !== false;
    })
  );

  const icons = {
    "/inventory_report": (
      <PiVaultBold className=" h-4 w-4 text-[#4154f1]"  />
    ),
    "/sale_report": (
      <HiOutlineShoppingCart className=" h-5 w-5 text-[#4154f1]" />
    ),
    // "/aging_report": (
    //   <FileClock height={"16px"} width={"16px"} color="#4154f1" />
    // ),
    "/price_co-pilot": (
      <IoPricetagsOutline className=" h-5 w-5 text-[#4154f1]" />
    ),
    "/stock_performance": (
      <TbPresentationAnalytics className=" h-5 w-5 text-[#4154f1]" />
    ),
    "/saved_search": (
      <TbReportSearch className=" h-5 w-5 text-[#4154f1]" />
    ),
    "/dashboard": (
      <MdOutlineAnalytics className="h-5 w-5 text-[#4154f1]" />
    ),


    "/market_performance": (
      <AiOutlineStock className="h-5 w-5 text-[#4154f1]" />
    ),
    "/selection": (
      <IoListCircleOutline className="h-5 w-5 text-[#4154f1]" />
    ),
  };
  

  const location = useLocation();

  const variants = {
    visible: {
      opacity: 1,
      width: "100%",
      display: "flex",
      transition: { duration: 0.3, delay: 0.2 },
    },
    hidden: {
      opacity: 0,
      width: "0%",
      display: "none",
      transition: { duration: 0.2 },
    },
  };

  return (
    <>
      {Object.entries(routes).map(([k, v]) => (
        <NavLink to={k} style={{ textDecoration: "none" }} key={k}>
          {/* {shouldRenderContent ? (
            
          ) : null} */}
          <motion.div
            className={cn(
              "py-2 px-4 cursor-pointer hover:bg-[#f6f9ff] rounded-lg mt-1 flex items-center gap-2 text-[#4154f1] font-semibold text-sm whitespace-nowrap",
              location.pathname.toString().includes(k) ? "bg-[#e0e7f5]" : "",
              !isVisible ? "px-2 w-full " : ""
            )}
            variants={variants}
            initial={isVisible ? "visible" : "hidden"}
            animate={isVisible ? "visible" : "hidden"}
            exit="hidden"
            style={{ whiteSpace: "nowrap" }}
          >
            <div className="h-4 w-4 flex justify-center items-center ">
              {icons[k]}
            </div>
            {v}
          </motion.div>
         <Tooltip title={routes[k]} placement="right-start"> 
          <motion.div
            className={cn(
              "py-2 px-4 cursor-pointer hover:bg-[#f6f9ff] rounded-lg mt-1 flex items-center justify-center gap-2 text-[#4154f1] font-semibold text-sm whitespace-nowrap",
              location.pathname.toString().includes(k) ? "bg-[#e0e7f5]" : "",
              !isVisible ? "px-2 w-full " : ""
            )}
            variants={variants}
            initial={!isVisible ? "visible" : "hidden"}
            animate={!isVisible ? "visible" : "hidden"}
            exit="hidden"
            style={{ whiteSpace: "nowrap" }}
          >
            <div className="h-4 w-4 flex justify-center items-center ">
              {icons[k]}
            </div>
          </motion.div>
          </Tooltip>
        </NavLink>
      ))}
    </>
  );
};

export default SidebarContent;
